import React from 'react';
import { cn } from "@/lib/utils";

interface AnimatedChar {
  char: string;
  id: number;
  direction: 'left' | 'right';
  x: number;
  y: number;
}

interface AnimatedCharactersProps {
  animatingChars: AnimatedChar[];
  combo: number;
}

const AnimatedCharacters = ({ animatingChars, combo }: AnimatedCharactersProps) => {
  return (
    <>
      {animatingChars.map(({ char, id, direction, x, y }) => (
        <div
          key={id}
          className={cn(
            "absolute pointer-events-none text-2xl font-bold opacity-0 z-30",
            direction === 'left' ? "animate-punch-left" : "animate-punch-right",
            combo >= 8 ? "text-accent" : combo >= 5 ? "text-secondary" : "text-primary"
          )}
          style={{
            left: `${x}px`,
            top: `${y}px`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          {char}
        </div>
      ))}
    </>
  );
};

export default AnimatedCharacters;